// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    PriorAuthorizationRequest,
    PriorAuthorizationRequestSearchRequest,
    PriorAuthorizationResultSearchRequest,
    PriorAuthorizationResultUpdateRequest,
    PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationDefaultResponse,
    PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationRequestSearchDefaultResponse,
    PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationResultSearchDefaultResponse,
    PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationResultUpdateDefaultResponse,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgePriorAuthorizationApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param priorAuthorizationRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async priorAuthorizationV1PriorAuthorization (priorAuthorizationRequest: PriorAuthorizationRequest, xProgramId?: string): Promise<AxiosResponse<PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationDefaultResponse>> {
        const _url_ = '/edge/priorAuthorization/v1/PriorAuthorization';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'priorAuthorizationRequest' is not null or undefined
        if (priorAuthorizationRequest === null || priorAuthorizationRequest === undefined) {
            throw new Error('Required parameter priorAuthorizationRequest was null or undefined when calling priorAuthorizationV1PriorAuthorization.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(priorAuthorizationRequest, "PriorAuthorizationRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param priorAuthorizationRequestSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async priorAuthorizationV1PriorAuthorizationRequestSearch (priorAuthorizationRequestSearchRequest: PriorAuthorizationRequestSearchRequest, xProgramId?: string): Promise<AxiosResponse<PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationRequestSearchDefaultResponse>> {
        const _url_ = '/edge/priorAuthorization/v1/PriorAuthorizationRequestSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'priorAuthorizationRequestSearchRequest' is not null or undefined
        if (priorAuthorizationRequestSearchRequest === null || priorAuthorizationRequestSearchRequest === undefined) {
            throw new Error('Required parameter priorAuthorizationRequestSearchRequest was null or undefined when calling priorAuthorizationV1PriorAuthorizationRequestSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(priorAuthorizationRequestSearchRequest, "PriorAuthorizationRequestSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationRequestSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationRequestSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param priorAuthorizationResultSearchRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async priorAuthorizationV1PriorAuthorizationResultSearch (priorAuthorizationResultSearchRequest: PriorAuthorizationResultSearchRequest, xProgramId?: string): Promise<AxiosResponse<PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationResultSearchDefaultResponse>> {
        const _url_ = '/edge/priorAuthorization/v1/PriorAuthorizationResultSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'priorAuthorizationResultSearchRequest' is not null or undefined
        if (priorAuthorizationResultSearchRequest === null || priorAuthorizationResultSearchRequest === undefined) {
            throw new Error('Required parameter priorAuthorizationResultSearchRequest was null or undefined when calling priorAuthorizationV1PriorAuthorizationResultSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(priorAuthorizationResultSearchRequest, "PriorAuthorizationResultSearchRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationResultSearchDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationResultSearchDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param priorAuthorizationResultUpdateRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async priorAuthorizationV1PriorAuthorizationResultUpdate (priorAuthorizationResultUpdateRequest: PriorAuthorizationResultUpdateRequest, xProgramId?: string): Promise<AxiosResponse<PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationResultUpdateDefaultResponse>> {
        const _url_ = '/edge/priorAuthorization/v1/PriorAuthorizationResultUpdate';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'priorAuthorizationResultUpdateRequest' is not null or undefined
        if (priorAuthorizationResultUpdateRequest === null || priorAuthorizationResultUpdateRequest === undefined) {
            throw new Error('Required parameter priorAuthorizationResultUpdateRequest was null or undefined when calling priorAuthorizationV1PriorAuthorizationResultUpdate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(priorAuthorizationResultUpdateRequest, "PriorAuthorizationResultUpdateRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationResultUpdateDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PriorAuthorizationV1PriorAuthorizationV1PriorAuthorizationResultUpdateDefaultResponse");
        }
        return response;
    }
}
